<template>
  <div id="page-events">

    <div v-if="loading" class="d-flex justify-content-center mb-8 mt-8">
      <memlist-spinner />
    </div>
    <div v-else>
      <memlist-inline-alert
        v-if="no_events"
        variant="danger"
        >{{$t('EVENT.NO_EVENTS')}}</memlist-inline-alert
      >

      <m-row v-else>
        <m-col lg="8" sm="12">

          <div class="top-image" v-if="main_event.image_xl">
            <img
              :src="('data:image/png;base64,' + main_event.image_xl)"
              alt="Preview"
              style="width: 100%;"
            />
          </div>

          <div class="page-header mb-8 mt-8">
            <h2>{{ main_event.company.name }}</h2>
          </div>

          <div class="events-section">
            <div class="events-upcoming">
              <h3>{{ $t('NATT.UPCOMING_EVENTS')}}</h3>

              <NattEventRow v-for="(i, index) in upcoming_events" :key="i" class="event-row mt-8" :event="i" />
            </div>
          </div>

          <div class="events-section mt-24">
            <div class="events-upcoming">
              <h3>{{ $t('NATT.PREVIOUS_EVENTS')}}</h3>

              <NattEventRow v-for="(i, index) in previous_events" :key="i" class="event-row mt-8" :event="i" />
            </div>
          </div>

        </m-col>
        <m-col lg="4" sm="0">
          <m-row>
            <m-col lg="12">
              <google-map
                v-if="main_event.google_maps"
                :center="{ lat: main_event.google_maps.lat, lng: main_event.google_maps.lng }"
                :zoom="16"
                style="height: 256px"
                id="map"
                ref="Map"
                class="shadow-sm p-2 mb-5 rounded"
              >
                <google-map-marker
                  :position="{ lat: main_event.google_maps.lat, lng: main_event.google_maps.lng }"
                ></google-map-marker>
              </google-map>
            </m-col>
          </m-row>
          <m-row>
            <m-col lg="12">
              <div class="side-container">
                <div class="side-content">
                  <p>{{main_event.company.name || ''}}</p>
                  <p>{{main_event.company.street || ''}}</p>
                  <p>{{main_event.company.zipcode || ''}} {{main_event.company.post || ''}}</p>
                </div>

                <div class="side-content">
                  <h4>Kontaktperson</h4>
                  <p>{{main_event.company.c_name || ''}}</p>
                </div>

                <div class="side-content">
                  <h4>Telefon</h4>
                  <p>{{main_event.company.c_phone || ''}}</p>
                  
                </div>

                <div class="side-content">
                  <h4>E-postadress</h4>
                  <p>{{main_event.company.c_email || ''}}</p>
                </div>


                <div class="side-content">
                  <h4>Hemsida</h4>
                  <p>{{main_event.company.web || ''}}</p>
                </div>

              </div>
            </m-col>
          </m-row>

          
        </m-col>
      </m-row>

    </div>

    
    

  </div>
</template>

<script>
import messageParent from '@/core/services/messageParent';
import axios from 'axios';
import dayjs, { Dayjs } from 'dayjs';
import { mapGetters } from 'vuex';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import i18nService from "@/core/services/i18n.service.js";
import NattEventRow from './NattEventRow.vue'

export default {
  name: 'NattEventPublicList',
  components: {
    NattEventRow
  },
  mixins: [ toasts ],
  computed: {
    ...mapGetters(['currentMember'])
  },
  async mounted() {
    this.loading = true;
    this.main_event_id = this.$route.params.main_event_id;

    await this.load_recurring_events(this.main_event_id);
  },
  data() {
    return {
      loading: true,

      no_events: true,
      
      main_event_id: null,
      main_event: {
        
      },
      upcoming_events: [
        /*{
          company: {
            name: 'Husby boysen'
          },
          event_id: 1,
          from_datetime: '2025-05-12 20:00',
          name: 'Vandring i husby',
          postaladdress: 'Husby centrum'
        },
        {
          company: {
            name: 'Husby boysen'
          },
          event_id: 2,
          from_datetime: '2025-05-12 20:00',
          name: 'Vandring i husby',
          postaladdress: 'Husby centrum'
        }*/
      ],
      previous_events: [],
      
    };
  },
  watch: {
  },
  methods: {

    async load_recurring_events(event_id) {
      try {
        const res = await axios.get(`/events/public/recurring/${event_id}`);

        if (res.status === 200) {
          this.recurring_items = res.data.events;
          this.main_event = res.data.main_event;
          this.main_event = { ...this.main_event };

          // split into past vs. current + future
          const now = new Date();                // local time (browser’s TZ)

          this.previous_events = [];
          this.upcoming_events = [];

          this.recurring_items.forEach(ev => {
            // ‑‑‑ defensive parsing in case to_datetime is null/undefined
            const to = ev && ev.to_datetime ? new Date(ev.to_datetime) : null;

            if (ev.status !== 'ACTIVE') {
              return;
            }

            if (to && to < now) {
              this.previous_events.push(ev);     // event ended in the past
            } else {
              this.upcoming_events.push(ev);     // still running or in the future
            }
          });

          this.previous_events = [ ...this.previous_events ];
          this.upcoming_events = [ ...this.upcoming_events ];

          this.no_events = this.previous_events.length === 0 && this.upcoming_events.length === 0;
          this.loading = false;

          return;
        }

      }
      catch (err) {
        console.error('load_recurring_events error', err);
      }

      this.recurring_items = [];

      this.no_events = this.previous_events.length === 0 && this.upcoming_events.length === 0;
      this.loading = false;
    },
    
    async load_company() {
      try {
        const res = await axios.get(`/company/public/${this.company.company_id}`);
        
        if (res.status === 200) {
          this.company = res.data;
        }
      }
      catch (err) {
        console.error('load_company error', err);
        this.toastr('danger', this.$t('COMMON.ERROR'), 'Kunde inte hämta förening');
      }
    },
    
  }
};
</script>
<style scoped>

h3 {
  font-size: 22px;
  font-weight: bold;
}

p {
  margin-bottom: 0px !important;
}
.name-title {
  color: #8b0000e6;
}
.events-section {
  font-size: 16px;
}
.event-row {
  display: flex; 
  flex-wrap: wrap;
  align-items: flex-end;
}
.side-container {
  background-color: #373f7c;
  color: white;
}

.side-content {
  padding: 12px;
  font-size: 16px;
  margin-bottom: 22px;
}

</style>